import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { HolidayPayObligation } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import ContinueButton from '@/components/ContinueButton.vue';
    import HolidayPayObligationsTableExport from '@/components/holiday-pay-obligations/HolidayPayObligationsTableExport.vue';
    import { router } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayPayObligationsTableActions',
  props: {
    holidayPayObligation: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasPermission } = usePermissions();

    const editHolidayPayObligation = () => {
        router.visit(
            route('v2.salary.holiday-pay-obligations.edit', {
                companyId: props.holidayPayObligation.company_id,
                id: props.holidayPayObligation.payroll_id,
            }),
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.holidayPayObligation }, {
    default: _withCtx(() => [
      _createVNode(ContinueButton, { onClick: editHolidayPayObligation }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('forms.open')), 1)
        ]),
        _: 1
      }),
      (_unref(hasPermission)(_unref(Permission).HOLIDAY_PAY_OBLIGATIONS_UPDATE))
        ? (_openBlock(), _createBlock(HolidayPayObligationsTableExport, {
            key: 0,
            "holiday-pay-obligation": _ctx.holidayPayObligation
          }, null, 8, ["holiday-pay-obligation"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})